import * as React from 'react'

interface MicrosoftSigninButtonProps {
	microsoftLogin: () => void
	text: string
	width?: string
}

const MicrosoftSigninButton: React.FunctionComponent<MicrosoftSigninButtonProps> = (props) => {
	return (
		<div className="btn btn__secondary btn--microsoft" onClick={props.microsoftLogin}>
			Sign up with Microsoft
		</div>
	)
}

export default MicrosoftSigninButton
